module.exports = __webpack_public_path__ + "static/img/QR.da7aa4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/QR.jpg
// module id = 504
// module chunks = 1